import useAxios from '@hooks/useFetch';
import { useCallback } from 'react';
import { paths } from "@api/api";

const REQUEST_FLAVOR_ACCESS_ENDPOINT: keyof paths = '/SubscribeRequest/Flavor';

type RequestFlavorAccessPayload = {
    countryCode: string;
    toolLocation: string;
};

export default function useRequestFlavorAccess() {
    const {
        isLoading,
        error,
        doFetch,
    } = useAxios<void, RequestFlavorAccessPayload>({
        method: 'post',
        url: REQUEST_FLAVOR_ACCESS_ENDPOINT,
        lazy: true,
    });

    const requestAccess = useCallback(async (countryCode: string, toolLocation: string) => {
        await doFetch({ data: { countryCode, toolLocation } });
    }, [doFetch]);

    return {
        requestAccess,
        isLoading,
        error,
    };
}
